export default {"src":"/_next/static/media/mojitoLogo.8e504c2c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};